<template>
    <div class="container mar-bt2">
        <div class="row mar-tp1 mar-bt2 align-items-center">
            <i class="fa fa-bandcamp fa-lg mar-r1 text-info"></i>
            <h6>当前位置&nbsp;>&nbsp;<router-link to="/home">首页</router-link>&nbsp;>&nbsp;关于我们</h6>
        </div>
        <div class="row">
            <div class="col-7 text-left"><p>    杭州易梵科技有限公司（简称：易梵科技），是一家技术驱动型高新企业，公司核心业务为软件产品的研发和行业应用解决方案，主要服务于教育机构、政府部门、各企事业单位及科研院所。<p/>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;公司以绿色创新为基础，在软件产品中融入AI元素，其产品涉及在线教育、企业进销存、企业财务管理、建筑劳务管理等领域。公司秉承互联网+教育的先进理念，未来重点核心业务为在线教育服务平台的研发，旨在为各教育机构提供一套专业的富含先进技术和人工智能元素的在线教育服务平台。<p/>
    <p>&nbsp;&nbsp;&nbsp;&nbsp;公司旗下的易梵少儿编程是专为7-16岁青少儿提供编程教育培训的机构，机构拥有一套完整的少儿编程教育课程体系，包括Scratch图形化编程、Python应用编程及C++信奥培训等内容，为广大青少儿提供优质教育服务。</p>
            </div>   
            <div class="col-5"><img class="img-suit img-thumbnail" src="../assets/images/aboutus.jpg" /></div>         
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped>

</style>